import React from 'react';
import * as Grants from '.././util/grants';
import { hasGrant } from '.././util/grantHelper';
import StockSearchData from './StockSearchData';
import LogisticsData from './CallOff/LogisticsData/index';
import CallOffToExistingCallOff from './CallOff/CallOffToExistingCallOff'
import CallOffCreate from './CallOffCreate';
import Dialog from 'react-bootstrap-dialog';
import NPSpinnerModalBetter from '../NPSpinnerModalBetter';
import axios from 'axios';
import constants from '../util/constants';
const { API_BASE_URL } = constants;

class StockSearch extends React.Component {
    constructor(props) {
        super(props);

        this.callOffCreate = this.callOffCreate.bind(this);
        this.callOffCopy = this.callOffCopy.bind(this);
        this.callOffModify = this.callOffModify.bind(this);
        this.callOffRelease = this.callOffRelease.bind(this);
        this.callOffToggleView = this.callOffToggleView.bind(this);
        this.callOffOpenReleased = this.callOffOpenReleased.bind(this);
        this.selectCopyLoadingNo = this.selectCopyLoadingNo.bind(this);
        this.getCombo = this.getCombo.bind(this);
        this.closeModalAction = this.closeModalAction.bind(this)
        this.getModalBody = this.getModalBody.bind(this);

        this.state = {
            apiToken: props.apiToken,
            loadData: true,
            legalEntity: null,
            callOffCreateShow: false,
            callOffToExistingCallOffShow: false,
            callOffFunctions: {
                create: this.callOffCreate,
                copy: this.callOffCopy,
                modify: this.callOffModify,
                release: this.callOffRelease,
                toggle: this.callOffToggleView,
                openReleased: this.callOffOpenReleased
            },
            callOff: {},
            callOffItem: {},

            callOffCopyByWeight: true,
            selectedCopyLoadingNo: null,

            showSpinnerModal: false,
            modalLoading: false,
            modalTitle: '',
            closeModalAction: this.closeModalAction
        };

        this.header = {
            'Authorization': 'Bearer ' + props.apiToken,
            'Accept': 'application/octet-stream'
        };
    }

    componentDidMount() {
        let legalEntity = sessionStorage.getItem('LegalEntity');
        this.setState({
            legalEntity: legalEntity
        })
    }

    callOffToggleView() {
        // Toggle CallOff create view
        this.setState({
            callOffCreateShow: !this.state.callOffCreateShow
        })
    }

    callOffCreate(order) {
        // Set selected order 
        this.setState({
            callOffOrder: order || {},
            callOff: {}
        });
        this.callOffToggleView();
    }

    callOffOpenReleased(callOff, refreshGetData) {
        let self = this;

        self.setState({
            callOff: callOff,
            showSpinnerModal: true,
            modalTitle: 'Opening released call off',
            modalLoading: true,
        }, () => openCallOff());

        function openCallOff() {
            axios.post(API_BASE_URL + 'CallOff/OpenReleased', {loadingNo: callOff.LOADING_NO}, {headers: self.header})
                .then(result => {
                    let message = "Successfully opened call off " + callOff.LOADING_NO
                    self.setState({ modalContent: message, modalLoading: false });
                    refreshGetData && refreshGetData()
                })
                .catch(error => {
                    let errorMessage = error?.response?.status === 400 && error?.response?.data || 'Could not set status to preliminary for call off with loading no:' + callOff.LOADING_NO;
                    self.setState({ modalContent: errorMessage, modalLoading: false });
                });
        }
    } 

    getModalBody(combo){
        return (
            <div>
                <div>
                    <span>Note that it is not possible to place reels to call offs with location different from this order's location.</span>
                    <br/>
                    <span>It is also not possible to place reels to call offs with delivery address different from this order's delivery address.</span>
                </div>
                <br/>
                {combo}
            </div>
        );
    }

    callOffCopy(order, refreshGetData) {
        let self = this;

        self.setState({
            showSpinnerModal: true,
            modalTitle: 'Copy order to existing call off',
            modalLoading: true
        });

        // Get available loading numbers for copy
        axios.get(API_BASE_URL + 'CallOff/GetCalloffsForAddingOrder',
            {
                params: { clientCodeRegional: order.CLIENT_CODE_REGIONAL, orderNumber: order.ORDER_NUMBER, orderItemNumber: order.ORDER_ITEM_NUMBER, palletLocationArea: order.ACTUAL_PALLET_LOCATION_AREA },
                headers: this.header
            })
            .then(result => {
                if (!result.data || result.data.length == 0) {
                    let errorMessage = `Could not find valid call offs for ${order.ORDER_NUMBER}-${order.ORDER_ITEM_NUMBER}.` 
                    
                    let {legalEntity} = self.state;
                    legalEntity === "NP"
                    ? errorMessage = errorMessage + `Call offs can only have one of each order item and all order items must have the same delivery address and be in the same country` 
                    : errorMessage = errorMessage + `Call offs can only have one of each order item and all order items must have the same delivery address and be in the same warehouse.`    

                    self.setState({ modalContent: errorMessage, modalLoading: false });
                    return false;
                }
                self.setState({
                    showSpinnerModal: false,
                    modalLoading: false
                }, () => displayCopyModal(result.data))
            })

        function displayCopyModal(callOffsForCopy) {
            self.dialog.show({
                title: "Call off order row into existing preliminary Call Off",
                body: self.getModalBody(self.getCombo('Call off to call off', "callOff", self.selectCopyLoadingNo, 'Loading number', callOffsForCopy, "150px", false)),
                actions: [
                    Dialog.CancelAction(() => {
                        self.setState({
                            selectedCopyLoadingNo: null
                        })
                    }),
                    Dialog.OKAction((res) => {
                        if (self.state.selectedCopyLoadingNo == null) return false;
                        self.dialog.show({
                            bsSize: 'medium',
                            title: "Select order amount for call off",
                            body: <CallOffToExistingCallOff order={order} legalEntity={self.state.legalEntity} />,
                            actions: [
                                Dialog.CancelAction(() => {
                                    self.setState({
                                        loadingNo: null
                                    })
                                }),
                                Dialog.OKAction((res) => {
                                    self.setState({
                                        showSpinnerModal: true,
                                        modalTitle: 'Call off order to existing call off',
                                        modalLoading: true
                                    })

                                    order.plannedQuantity = order.PLANNED_QUANTITY || 0;
                                    order.plannedWeight = order.PLANNED_WEIGHT_UC || 0;

                                    if (order.plannedQuantity == 0 && order.plannedWeight == 0) {
                                        let errorMessage = "Call off amount must exist. Both weight and quantity was 0"
                                        self.setState({ modalContent: errorMessage, modalLoading: false });
                                        return false;
                                    }

                                    let callOffItem = {
                                        LOADING_NO: self.state.selectedCopyLoadingNo,
                                        CLIENT_CODE_REGIONAL: order.CLIENT_CODE_REGIONAL,
                                        ORDER_NUMBER: order.ORDER_NUMBER,
                                        ORDER_ITEM_NUMBER: order.ORDER_ITEM_NUMBER,
                                        PLANNED_QUANTITY: order.plannedQuantity,
                                        PLANNED_WEIGHT_UC: order.plannedWeight,
                                        AVAILABLE_QUANTITY: order.QUANTITY,
                                        AVIALABLE_WEIGHT: order.WEIGHT,
                                        PRODUCT_CODE: order.PRODUCT_CODE,
                                        PALLET_LOCATION_AREA: order.ACTUAL_PALLET_LOCATION_AREA
                                    }
                                    callOffItem = JSON.stringify(callOffItem);

                                    axios.post(API_BASE_URL + 'CallOff/CopyToCallOff',
                                        callOffItem,
                                        {
                                            headers: { ...self.header, 'Content-Type': 'application/json' }
                                        })
                                        .then(res => {
                                            let successMessage = `Successfully added order ${order.ORDER_NUMBER}-${order.ORDER_ITEM_NUMBER} to call off with loading no: ${self.state.selectedCopyLoadingNo}`
                                            self.setState({ modalContent: successMessage, modalLoading: false });
                                            self.setState({ loadData: false }, () => self.setState({ loadData: true }))
                                        })
                                        .catch(error => {
                                            let errorMessage = error?.response?.status === 400 && error?.response?.data || 'Unknown error when trying to call off order to loading no: ' + self.state.selectedCopyLoadingNo;
                                            self.setState({ modalContent: errorMessage, modalLoading: false });
                                        })
                                })
                            ]
                        })
                    })
                ]
            })
        }
    }

    callOffModify(callOff) {
        this.setState({
            callOff: callOff
        }, () => {
            this.callOffToggleView();
        });
    }

    callOffRelease(callOff, refreshGetData) {
        let self = this;

        this.setState({
            callOff: callOff,
            showSpinnerModal: true,
            modalLoading: true,
            modalTitle: 'Releasing call off'
        }, () => releaseCallOff());

        function releaseCallOff() {
            let payload = JSON.stringify({
                loadingNo: callOff.LOADING_NO,
                env: process.env.REACT_APP_BASE_CATALOG
            });

            axios.post(API_BASE_URL + 'CallOff/ReleaseCallOff', payload,
                {
                    headers: { ...self.header, 'Content-Type': 'application/json' }
                })
                .then(result => {
                    self.setState({
                        modalContent: `Released call off: ${callOff.LOADING_NO}.`,
                        modalLoading: false
                    });
                    refreshGetData && refreshGetData()
                })
                .catch(error => {
                    let errorMessage = error?.response?.status === 400 && error?.response?.data || 'Could not release call off: ' + callOff.LOADING_NO
                    self.setState({ modalContent: errorMessage, modalLoading: false });
                });
        }
    }

    selectCopyLoadingNo(item) {
        this.setState({
            selectedCopyLoadingNo: item.target.value
        })
    }

    getCombo(_caption, _stateObj, _onChange, _placeHolder, _options, _width = "auto", _clearable = true, disabled = false) {
        let mystyle = {
            padding: "10px",
            width: "150px",
            borderRadius: "5px"
        }
        let divInputStyling = { display: 'flex', justifyContent: 'center' }
        return (
            <div style={divInputStyling}>
                <select style={mystyle} placeholder={_placeHolder} onChange={(item) => _onChange(item, _stateObj)}>
                    <option value={null}>{_placeHolder}</option>
                    {_options.map((object) => { return (<option key={object} value={object}>{object}</option>) })}
                </select>
            </div>
        );
    }

    closeModalAction() {
        this.setState({
            showSpinnerModal: false,
            modalLoading: false,
            modalContent: null,
            modalTitle: null
        })
    }

    render() {
        return (
            <div>
                <Dialog ref={(el) => { this.dialog = el }} />
                <NPSpinnerModalBetter showModal={this.state.showSpinnerModal} title={this.state.modalTitle} content={this.state.modalContent} closeAction={this.state.closeModalAction} isLoading={this.state.modalLoading} />

                {
                    this.state.callOffCreateShow &&
                    <React.Fragment>
                        <CallOffCreate apiToken={this.state.apiToken}
                            callOff={this.state.callOff}
                            callOffOrder={this.state.callOffOrder}
                            callOffFunctions={this.state.callOffFunctions} />
                    </React.Fragment>
                }

                {
                    this.state.loadData && this.state.callOffCreateShow == false && hasGrant(Grants.TYPES.Stock_ViewStock) &&
                    <React.Fragment>
                        <StockSearchData apiToken={this.state.apiToken} callOffFunctions={this.state.callOffFunctions} />
                    </React.Fragment>
                }

                {
                    this.state.loadData && this.state.callOffCreateShow == false && hasGrant(Grants.TYPES.Stock_SeeCalloff) &&
                    <React.Fragment>
                        <LogisticsData apiToken={this.state.apiToken} callOffFunctions={this.state.callOffFunctions} />
                    </React.Fragment>             
                }

            </div>
        )
    }
}

export default StockSearch;